import type {ReactElement} from 'react';
import {PanelHeader} from '@Components/panel';
import useWindowSize from '@Hooks/useWindowSize';
import type {CheckoutFlowHeaderProps} from '@Components/checkout-flow/components/checkout-flow-header/checkout-flow-header.types';
import {getCheckoutModalTitle, isCheckoutBottomSheet} from '@Components/checkout-flow/checkout-flow.library';

export function CheckoutFlowHeader({flow}: CheckoutFlowHeaderProps): ReactElement | null {
  const {windowWidth} = useWindowSize();
  if (!flow.showsPanelHeader) {
    return null;
  }

  const centersTitle = isCheckoutBottomSheet(windowWidth);

  return (
    <PanelHeader
      title={getCheckoutModalTitle(flow.request, flow.step)}
      centerAlignTitle={centersTitle}
      forceCenterAlignTitleWithActionItems={centersTitle}
      showBackButton={flow.canGoBack}
      onBackButton={flow.controller.goBack}
      onClose={flow.controller.exit}
      isOpenedInModal
    />
  );
}
